// @flow
import { Component } from 'react';
import { connect } from 'react-redux';
import mapboxgl from 'mapbox-gl';


type MapLinePropTypes = {
  map: mapboxgl.Map,
  id: number,
  path: Object
};

class MapLine extends Component<MapLinePropTypes> {
  componentDidMount() {
    const { map, path, id } = this.props;

    if (map && path && map.getLayer(`route ${id}`) === undefined) {
      map.addLayer({
        id: `route ${id}`,
        type: 'line',
        source: {
          type: 'geojson',
          data: {
            type: 'Feature',
            geometry: path,
          },
        },
        paint: {
          'line-width': 6,
          'line-color': 'skyblue',
          'line-opacity': 0.85,
        },
      });
    }
  }

  componentWillReceiveProps(nextProps: MapLinePropTypes) {
    const { map, path, id } = nextProps;
    const layer = map.getLayer(`route ${id}`);

    if (map && path && layer !== undefined) {
      const source = map.getSource(layer.source);
      source.setData({
        type: 'Feature',
        geometry: path,
      });
    }
  }

  componentWillUnmount() {
    const { map, id } = this.props;
    // Remove Map Point from map
    if (map && id && map.getLayer(`route ${id}`)) {
      map.removeLayer(`route ${id}`);
      map.removeSource(`route ${id}`);
    }
  }

  render() {
    return null;
  }
}


export default connect(undefined, undefined)(MapLine);



// WEBPACK FOOTER //
// ./src/scripts/components/MapLine/index.jsx